import { AfterViewInit, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { StateService } from '@uirouter/core';
import { combineLatest, merge, Observable, ReplaySubject } from 'rxjs';
import { filter, map, scan, take } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging';
import { QuickbooksService } from '../quickbooks.services';
import * as fromStore from '../store';
import * as fromShared from '../../shared';
import * as fromSettings from '../../company-setting';
@Component({
    selector: 'ef-sync-lists',
    templateUrl: './sync-lists.component.html',
    styleUrls: ['./sync-lists.component.scss'],
    standalone: false
})
export class SyncListsComponent implements OnInit, AfterViewInit {
    /**
     *
     */
    public StatusSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
    public SyncEnabledSubject: ReplaySubject<boolean> =
        new ReplaySubject<boolean>(1);
    public AllStatuses: Observable<any>;
    private validTokens: boolean;
    process$: Observable<fromShared.Process>;
    isGCPEnabled$: Observable<boolean>;
    async syncLists() {
        // catch errors and display them
        this.SyncEnabledSubject.next(false);
        //INFO: DO NOT MESS WITH THE ORDER unless you are aware of the dependencies
        this.isGCPEnabled$.pipe(take(1)).subscribe(async gcp => {
            this.log.verbose({ type: 'SyncListsComponent:syncLists', gcp });
            if (this.validTokens) {
                try {
                    this.StatusSubject.next(
                        '<div>Syncing Company Info...</div>'
                    );
                    await this.service.SyncCompanyInfo();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Company Info Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next(
                        '<div>Syncing Preferences...</div>'
                    );
                    await this.service.SyncPreferences();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Preferences Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next('<div>Syncing Vendors...</div>');
                    await this.service.SyncVendors();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Vendors Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next(
                        '<div>Syncing Customer Jobs...</div>'
                    );
                    await this.service.SyncCustomerJobs();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Customer Jobs Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next('<div>Syncing Accounts...</div>');
                    await this.service.SyncAccounts();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Accounts Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next(
                        '<div>Syncing Service Items...</div>'
                    );
                    await this.service.SyncServiceItems();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Service Items Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next(
                        '<div>Syncing Inventory Items...</div>'
                    );
                    await this.service.SyncInventory();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Inventory Items Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }

                try {
                    this.StatusSubject.next(
                        '<div>Syncing Non-Inventory Items...</div>'
                    );
                    await this.service.SyncNonInventory();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Non-Inventory Items Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }
                try {
                    this.StatusSubject.next('<div>Syncing Classes...</div>');
                    await this.service.SyncClasses();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Classes Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }
                //checking sendtoQBO is now handled in stored proc so don't need to check here
                //2023-12-10: what stored proc, where? - ef_qbi_employee_get does the check and filters, but we still need to call SendEmployees
                //but we don't want to display the messages...
                // if (sendtoQBO) {
                if (gcp) {
                    try {
                        this.StatusSubject.next(
                            '<div>Sending Employees...</div>'
                        );
                        await this.service.SendEmployees();
                        this.StatusSubject.next(
                            '<div class="success">Sending Employees Complete...</div>'
                        );
                    } catch (error) {
                        this.errorProc(error);
                    }
                }
                // }
                try {
                    this.StatusSubject.next('<div>Syncing Employees...</div>');
                    await this.service.SyncEmployees();
                    this.StatusSubject.next(
                        '<div class="success">Syncing Employees Complete...</div>'
                    );
                } catch (error) {
                    this.errorProc(error);
                }
                this.StatusSubject.next(
                    '<div class="success">Sync Complete</div>'
                );
                this.SyncEnabledSubject.next(true);
            }
        });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.SyncEnabledSubject.next(true);
            this.StatusSubject.next('');
        }, 0);

        const add = (value: any) => state => state + value;
        const clear = () => state => [];
        this.AllStatuses = merge(
            this.StatusSubject.pipe(map(add)),
            this.SyncEnabledSubject.pipe(
                filter(x => !x),
                map(clear)
            )
        ).pipe(scan((state, innerFn) => innerFn(state), []));

        this.store
            .pipe(select(fromStore.getHasValidTokens))
            .subscribe(valid => {
                this.validTokens = valid;
                if (!valid) {
                    this.ss.go('main');
                } else {
                    this.SyncEnabledSubject.next(true);
                    this.StatusSubject.next('');
                }
            });

        this.isGCPEnabled$ = this.store.pipe(select(fromSettings.isGCPEnabled));
    }
    ngOnInit(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
    }
    errorProc = error => {
        this.log.error({
            type: 'SyncListsComponent:syncLists',
            error
        });
        this.StatusSubject.next(
            `<div class='error'>${
                typeof error.error === 'string'
                    ? error.error
                    : error.Message ||
                      error.message ||
                      error.error?.ExceptionMessage ||
                      error.error?.Message ||
                      'An unknown error occurred'
            }</div>`
        );
        if (error.status === 424) {
            setTimeout(() => {
                this.store.dispatch(new fromStore.ValidateTokens());
            }, 5000);
            throw error;
        }
        // this.SyncEnabledSubject.next(true);
    };
    constructor(
        private service: QuickbooksService,
        private store: Store,
        private ss: StateService,
        private log: LoggingService
    ) {
        this.store.dispatch(new fromStore.ValidateTokens());
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: fromSettings.CompanySettingEnum.ExternalEmployeeSource
            })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: fromSettings.CompanySettingEnum.SendEmployeetoQB
            })
        );
    }
}
